module.exports = __webpack_public_path__ + "static/img/13062B_2_C_20200428_LC.8de65ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13062B_2_C_20200428_LC.png
// module id = Jq70
// module chunks = 0